import { render, staticRenderFns } from "./FigmaLayerSelector.vue?vue&type=template&id=25aa2d3e"
import script from "./FigmaLayerSelector.vue?vue&type=script&lang=js"
export * from "./FigmaLayerSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25aa2d3e')) {
      api.createRecord('25aa2d3e', component.options)
    } else {
      api.reload('25aa2d3e', component.options)
    }
    module.hot.accept("./FigmaLayerSelector.vue?vue&type=template&id=25aa2d3e", function () {
      api.rerender('25aa2d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/figma-layers/FigmaLayerSelector.vue"
export default component.exports